import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Select = (props) => {
  return (
    <select
      className={classNames('transition-colors duration-150 ease-in-out h-12 pl-4 pr-10 cursor-pointer border-grey border rounded bg-chevron-down bg-no-repeat bg-right-4 bg-3 appearance-none outline-none focus:border-charcoal hover:border-charcoal truncate', props.className)}
      value={props.value}
      onChange={props.onChange && props.onChange}
    >
      {props.placeholder &&
      <option value="">
        {props.placeholder}
      </option>}

      {props.items.map((item, index) => (
        <option key={index} value={item.value}>
          {item.name}
        </option>
      ))}
    </select>
  )
}

Select.propTypes = {
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string
  })).isRequired
}

export default Select
